import lodash from 'lodash'
import React, { ReactElement, useEffect, useMemo } from 'react'
import styled from 'styled-components'

import Checkbox from '../../../../../1stlog-ui/src/components/Checkbox'
import Disabled from '../../../../../1stlog-ui/src/components/Disabled'
import Field, { useField } from '../../../../../1stlog-ui/src/components/Field'
import useOrderEntry from '../../useOrderEntry'

const Wrapper = styled.div`
  display: inline-block;
`

const PrintLabelRequested = (): ReactElement => {
  const { currentPrinter } = useOrderEntry()

  const [isPrintRequested, setIsPrintRequested] = useField('isPrintRequested', {
    asState: true,
  })

  const noPrinterSelected = useMemo(
    () => !lodash.get(currentPrinter, 'name'),
    [currentPrinter],
  )

  useEffect(() => {
    if (noPrinterSelected) {
      setTimeout(() => setIsPrintRequested(false), 0)
    }
  }, [noPrinterSelected])

  return (
    <Wrapper>
      <Disabled
        disabled={noPrinterSelected}
        tooltip={i18n.t('no_printer_selected', 'Kein Drucker ausgewählt')}
      >
        <Field name="isPrintRequested">
          <Checkbox
            label={`${i18n.t(
              'send_label_to_selected_printer',
              'Buchungslabel an gewählten Drucker senden',
            )} (${lodash.get(
              currentPrinter,
              'name',
              i18n.t(
                'please_select_printer_first',
                'Bitte zuerst Drucker auswählen',
              ),
            )}) `}
          />
        </Field>
      </Disabled>
    </Wrapper>
  )
}

export default PrintLabelRequested
